import React from 'react';

export default function GridStatCard({ items = [], theme = {} }) {
    const {
        columns = 2,
        valueClass = 'text-2xl font-semibold text-[#0F172A]',
        labelClass = 'text-base text-[#585858] font-medium',
        gapY = 'gap-y-8',
        gapX = 'gap-x-12',
    } = theme || {};

    const gridColsClass = `grid-cols-${Math.max(1, Math.min(4, Number(columns) || 2))}`;

    return (
        <div className={`grid ${gridColsClass} ${gapX} ${gapY} mt-7`}>
            {Array.isArray(items) && items.map((it, idx) => (
                <div key={`${it?.label ?? idx}`} className="flex flex-col">
                    <div className={valueClass}>{Number(it?.value ?? 0)}</div>
                    <div className={labelClass}>{it?.label ?? ''}</div>
                </div>
            ))}
        </div>
    );
}


